// 获取单个类型的value
export function getSingleTypeValue(list, key) {
  // console.log(list);
  // console.log(key);
  let value = "";
  list.forEach((item) => {
    if(item.children){
      item.children.forEach((child) => {
        if (item.dataType + item.dataCode + child.dataCode == key)
          value = child.dataValue;
      });
    }
  
  });

  return value;
}

// 获取单个类型的value
export function getSingleTypeCode(list, key) {
  // console.log(list);
  // console.log(key);
  let value = "";
  list.forEach((item) => {
    if(item.children){
      item.children.forEach((child) => {
        if (item.dataType + item.dataCode + child.dataValue == key)
          value = child.dataCode;
      });
    }
  
  });

  return value;
}


// 获取下拉框的value
export function getSelectValue(list, id) {
  // console.log(list);
  // console.log(id);
  let value = "";
  list.forEach((item) => {
    if (item.id == id) value = item.name;
  });

  return value;
}
